import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TestCategory } from "types/testTypes";

export interface TestSessionState {
  completedTestIds: string[];
  vfaAutoRestartCount: number;
  vfaAutoRestartTestCategory: TestCategory | null;
}

const initialState: TestSessionState = {
  completedTestIds: [],
  vfaAutoRestartCount: 0,
  vfaAutoRestartTestCategory: null,
};

const testSessionSlice = createSlice({
  name: "testSession",
  initialState,
  reducers: {
    addCompletedTestId(state, action: PayloadAction<string>) {
      const id = action.payload;
      if (id && !state.completedTestIds.includes(id)) {
        state.completedTestIds.unshift(id);
      }
    },
    incrementVfaAutoRestartCount(state, action: PayloadAction<TestCategory | undefined>) {
      state.vfaAutoRestartCount += 1;
      state.vfaAutoRestartTestCategory = action.payload ?? null;
    },
    resetVfaAutoRestartCount(state) {
      state.vfaAutoRestartCount = 0;
      state.vfaAutoRestartTestCategory = null;
    },
    resetTestSession: (state) => ({
      ...initialState,
      vfaAutoRestartCount: state.vfaAutoRestartCount,
      vfaAutoRestartTestCategory: state.vfaAutoRestartTestCategory,
    }),
  },
});

export const {
  addCompletedTestId,
  incrementVfaAutoRestartCount,
  resetVfaAutoRestartCount,
  resetTestSession,
} = testSessionSlice.actions;

export default testSessionSlice.reducer;
